const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedSettingWord: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const settingword = (state = initialState, action) => {
	switch (action.type) {
		case 'SETTINGWORD_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'SETTINGWORD_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'SETTINGWORD_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'SETTINGWORD_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'SETTINGWORD_GET_CURRENT':
			return {
				...state,
				selectedSettingWord: action.selectedSettingWord,
			}
		case 'SETTINGWORD_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default settingword
